import {
  Anchor,
  Avatar,
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group, ScrollArea,
  Table,
  Text,
  Title
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { IconCamera } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { logger } from "utils/logger";
import { EmptyState } from "core/components/emptyState/EmptyState";
import { createStyles } from "@mantine/emotion";
import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";
import { selectStyle } from "modules/Distributions/distributionSlice";
import Moment from "react-moment";

import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import { MetaLabel } from "core/components/metaLabel/MetaLabel";
import StyleInfoSections from "core/components/styleInfoSections/StyleInfoSections";
import { getClientLabel } from "utils/helper";
import DateDisplay from "../dateDisplay/DateDisplay";

const useStyles = createStyles((theme, _, u) => ({
  container: {
    padding: 0,
    height: "100%",
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderTopStyle: "solid",
    borderLeftStyle: "solid",
    // paddingTop: 26,
    borderColor: theme.colors.dark[4],
    [u.light]: {
      borderColor: theme.colors.gray[3],
    },
    ".mantine-Accordion-content": {
      paddingBottom: 0,
    },
    ".mantine-Accordion-control": {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderColor: theme.colors.dark[4],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    ".mantine-Stack-root": {
      // gap: 0,
    },
    ".capture-selected > div > div:first-of-type": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
  },
  badgeIndex: {
    position: "absolute",
    left: 0,
    top: 0,
  },
}));

const StyleAssetInfoPanel = ({ selectedItem, style, user }) => {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("info");
  const [session, setSelectedSession] = useState(null);
  const [talent, setTalent] = useState([]);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const dateArr = selectedItem.actionSort.split('-');
  // const y = dateArr[0];
  // const m = dateArr[1];
  // const d = dateArr[2];
  // const h = dateArr[3];
  // const min = dateArr[4];
  // const s = dateArr[5];

  // const captureDate = moment(selectedItem.actionSort, 'YYYY-MM-DD-hh-mm-ss');

  useEffect(() => {
    logger.log(selectedItem);
    const getStyleInfo = async (id) => {
      setLoading(true);
      const data = await getStyle(id);
      try {
        if (data) {
          logger.log(data);
          const { masters, sessions, seasons, assets, ...rest } = data;
          dispatch(selectStyle({ ...data, masters, sessions, seasons, assets }));
        }
      } catch (e) {
        logger.error('Error getting style info', e);
        // dispatch(
        //   setError({
        //     type: ERROR_TYPES.NOT_FOUND,
        //     message: ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND],
        //   })
        // );
      } finally {
        setLoading(false);
      }
      // if (data) {
      //   logger.log(data);
      //   dispatch(selectStyle(data));
      // }
    };
    if (selectedItem && selectedItem.styleNumber) {
      if (
        !selectedItem.assets ||
        (selectedItem.assets.length === 0 && !hasFetched.current)
      ) {
        getStyleInfo(selectedItem.styleNumber);
        hasFetched.current = true;
      }
    }
  }, [selectedItem]);

  logger.log('++++++++++++',selectedItem);

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedAsset(data);
    setImageModalOpen(true);
  };

  return (
    <Box className={`${classes.container} info-panel unhightable`}>
      <div style={{ width: 400, height: "calc(100vh - 76px)" }}>
        <ScrollArea style={{ height: "100%" }}>
          {selectedItem ? (
            <Card pt="lg" style={{ background: "none", position: 'relative' }} p={"lg"} pb={0}>
              <Title className="main-content-heading" order={5}>
                Style Information
              </Title>
              <Box>
                <Group my="md">
                  <MetaLabel width="40%">Style Number</MetaLabel>
                  <div>
                    <Text size="sm">
                      <Anchor component={Link} to={`/distributions/${style.styleNumber}`}>
                        {style?.styleNumber}
                      </Anchor>
                    </Text>
                  </div>
                </Group>
                <Group my="md">
                  <MetaLabel width="40%">Department</MetaLabel>
                  <div>
                    <Text size="sm">{style.dept}</Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel width="40%">{getClientLabel(user.clientCode, 'otbDate')}</MetaLabel>
                  <div>
                    <Text size="sm">
                      {style.otbDate && style.otbDate.length ? (
                        <DateDisplay
                          value={style.otbDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        ""
                      )}
                    </Text>
                  </div>
                </Group>

                <Group mt="md">
                  <MetaLabel width="40%">Distribution Date</MetaLabel>
                  <div>
                    <Text size="sm">
                      {style.distributionDate &&
                      style.distributionDate.length ? (
                        <DateDisplay
                          value={style.distributionDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        ""
                      )}
                    </Text>
                  </div>
                </Group>
              </Box>

              <Divider my={'lg'} />

              <Box mb={'sm'}>
                <Group mb="lg">
                  <Title className="main-content-heading" order={6}>
                    Tags
                  </Title>
                  {selectedItem?.tags && selectedItem.tags.length ? (
                    <PrimaryBadge>{selectedItem?.tags?.split(",").length}</PrimaryBadge>
                  ) : null}
                </Group>
                <Group gap={"xs"} style={{ justifyContent: "flex-start" }}>
                  {selectedItem?.tags && selectedItem.tags.length ? (
                    null
                  ) : <Text size="sm" c={'dimmed'}>No tags available</Text>}
                  {selectedItem &&
                    selectedItem.tags &&
                    selectedItem.tags.length &&
                    selectedItem.tags.split(",").map((val, idx) => (
                      <Badge
                        key={idx}
                        color="gray"
                        variant="default"
                        gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
                      >
                        {val}
                      </Badge>
                    ))}

                  {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>Winter</Badge> */}
                </Group>

                {!selectedItem ||
                (selectedItem && selectedItem.assets?.length === 0) ? (
                  <EmptyState
                    caption="There are no assets"
                    style={{ height: 200 }}
                  />
                ) : null}
                {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
              </Box>

              <StyleInfoSections selectedItem={style} user={user} loading={loading} storageKey="op-dist-style-drawer" />
            </Card>
          ) : (
            <Center sx={{ height: "100%", minHeight: 400 }}>
              <div style={{ textAlign: "center" }}>
                <IconCamera size={48} stroke={1} />
                <Title color={"dimmed"} order={3}>
                  Select an Image
                </Title>
              </div>
            </Center>
          )}
        </ScrollArea>
      </div>
    </Box>
  );
};

export default StyleAssetInfoPanel;

export function TalentList({ data }) {
  const rows = data.map((item) => (
    <tr key={item.name}>
      <td>
        <Group spacing="sm">
          <Avatar size={40} src={item.avatar} radius={40} />
          <div>
            <Text size="sm" weight={500}>
              {item.name}
            </Text>
            <Text size="xs" color="dimmed">
              {item.email}
            </Text>
          </div>
        </Group>
      </td>

      {/* <td>
          
        </td>
        <td>{Math.floor(Math.random() * 6 + 5)} days ago</td>
        <td>
          {Math.random() > 0.5 ? (
            <Badge fullWidth>Active</Badge>
          ) : (
            <Badge color="gray" fullWidth>
              Disabled
            </Badge>
          )}
        </td> */}
    </tr>
  ));

  return (
    <Table verticalSpacing="sm">
      {/* <thead>
            <tr>
              <th>Employee</th>
              <th>Role</th>
              <th>Last active</th>
              <th>Status</th>
            </tr>
          </thead> */}
      <tbody>{rows}</tbody>
    </Table>
  );
}
